/**
 *
 */
import Matrix2d from '../../math/matrix2d/index.js';
// import { KLINE_PRICE_TYPE } from '@/viewmodel/index.js';
import { checkExchange,checkFutures,checkPower,getToFixed,zeroBug,checkMRI,checkSS } from '../../controller/util';
import Util, { mergeOption, mergeModelData, deepCopy,TradVolume,numberFormat } from '../../util/index.js';
import Hammer from 'hammerjs';
import { Conf } from '../config';
import { LINE_TYPE } from '../setting.js';
const DIRECTION_TOP = Symbol('向上');
const DIRECTION_DOWN = Symbol('向下');
const model = {
  code: {
    Type: String
  },
  graphConfig: {
    Type: Object,
    Required: false,
  },
  sealObj: {
    // 个股的基本数据
    Type: Object,
    Required: true,
  },
  start: {
    // 要展示数据的startPosition
    Required: true,
    Type: Number
  },
  end: {
    // 要展示数据的endPosition，可能比min_time的长度长
    Required: true,
    Type: Number
  },
  current: {
    // 要展示title的currentPosition
    Required: true,
    Type: Number
  },
  period: {
    Required: true
  },
  min_time: {
    Required: true,
    Type: Array,
    Default: () => ([])
  },
  len: {
    // 缓存min_time的长度
    Required: true,
    Type: Number,
  },
};
class RectObjs {
  constructor({x, y, _middleX, _axisYO, _axisYL, _axisYR, _axisYH, height,color, cahe, ctx,width}) {
    this.x = x;
    this.y = y;
    this._middleX = _middleX;
    this._axisYO = _axisYO;
    this._axisYL = _axisYL;
    this._axisYR = _axisYR;
    this._axisYH = _axisYH;
    this.height = height;
    this.width = width;
    this.cahe = cahe;
    this.ctx = ctx;
    this.color = color;
    this.creatObj()
  }
  creatObj () {
    this.ctx.rect(this.x, this.y, parseInt(this.width), parseInt(this.height));
    this.ctx.fill()
    this.ctx.moveTo(this._middleX, this._axisYO);
    this.ctx.lineTo(this._middleX, this._axisYL);
    this.ctx.moveTo(this._middleX, this._axisYR);
    this.ctx.lineTo(this._middleX, this._axisYH);
  }
}
// import Controller from '../../controller/index.js'
export default class BaseContext {
  constructor(props) {
    let {
      context,
      curContext,
      option,
      data,
      left,
      top,
      width,
      height,
      baseSize,
      isFullScreen,
      pageX=0,
      auth,
      dpr
    } = props;
    this.store={
      state:props.data
    }
    data = mergeModelData(model, data);
    if (data.hasOwnProperty('model')) {
      data = data.model;
    }
    const deepData = deepCopy({}, data);
    this.context = context;
    this.curContext = curContext;
    this.dpr = dpr;
    this.auth = auth;
    this.state = {
      scale: this.dpr,
      data: deepData, // 深拷贝，主辅视图数据独立
      left,
      top,
      width,
      height,
      baseSize,
      pageX,
      isFullScreen,
    };
    this.option = deepData.graphConfig ? mergeOption({}, Conf, deepData.graphConfig) : Conf;
    // 主画图区域
    this.availArea = {
      left: 0,
      top: 0,
      width: 0,
      height: 0,
      right: 0,
      bottom: 0
    };
    this.maxValue = undefined;
    this.minValue = undefined;
    this.baseValue = undefined;
    this._init();
  }
  _init() {
    if (this.state.data) {
      // 等实例化完成以后再画，确保构造函数完成
      this.draw()
      // setTimeout(() => {
      // }, 0);
    }
  }
  async _validEvent(e) {
    try {
      const isFullScreen = this.store.state.isFullScreen;
      let panX, panY;
      // 横竖屏区分计算
      if (isFullScreen) {
        panX = (e && e.changedPointers[0].clientX) || this.store.state.clientX;
      } else {
        panX = (e && e.changedPointers[0].pageX) || this.store.state.pageX;
      }
      if(panX==0){
        return
      }
      const {offsetWidth, offsetHeight} = document.getElementById('FOOT');
      if (!offsetWidth) {
        return;
      }
      const {transitionMatrix, transformOrigin, position} = this.store.state;
      if (!Util.isArray(transformOrigin) || transformOrigin.length !== 2) {
        return;
      }
      const [originX, originY] = transformOrigin;
      const [clientX, clientY] = position;
      const {pageX, pageY} = this.state;
      if(transitionMatrix==undefined){
        return
      }
      const matrix = Matrix2d.transition(transitionMatrix, [[panX - originX - clientX,1,1]]);
      panX = matrix[0][0] + clientX + originX;//store里面的position的clientX
      const x = panX - pageX;
      if (x >= 0
        && x <= offsetWidth
      ) {
        this.xValue.x=x
        return Promise.resolve({x});
      }
      // return Promise.reject('无效区域');
    } catch(e) {
      return Promise.reject(e);
    }
  }
  /*** 虚线 ***/
  _drawDash(
    pt1,
    pt2,
    line,
    style,
    lineWidth = 5,
    spaceWidth = 3,
    ctx
  ) {
    lineWidth = lineWidth * this.dpr;
    spaceWidth = spaceWidth * this.dpr;
    let { x: x1, y: y1 } = pt1;
    let { x: x2, y: y2 } = pt2;
    let totalStep = Math.ceil(Math.sqrt(Math.pow((x2 - x1), 2) + Math.pow((y2 - y1), 2)) / (lineWidth + spaceWidth));
    let currentStep = 0;
    let stepX = (x2 - x1) / totalStep * lineWidth / (lineWidth + spaceWidth);
    let stepY = (y2 - y1) / totalStep * lineWidth / (lineWidth + spaceWidth);
    let spaceX = (x2 - x1) / totalStep * spaceWidth / (lineWidth + spaceWidth);
    let spaceY = (y2 - y1) / totalStep * spaceWidth / (lineWidth + spaceWidth);
    ctx = ctx || this.context;
    let currentX = x1;
    let currentY = y1;
    ctx.beginPath();
    ctx.strokeStyle = style;
    ctx.lineWidth = line * this.dpr * 2;
    ctx.moveTo(x1, y1);
    for (; currentStep < totalStep; currentStep++) {
      currentX += stepX;
      currentY += stepY;
      ctx.lineTo(currentX, currentY);
      currentX += spaceX;
      currentY += spaceY;
      ctx.moveTo(currentX, currentY);
    }
    ctx.lineTo(x2, y2);
    ctx.stroke();
  }
  /*** 实线 ***/
  _drawSolid(
    pt1,
    pt2,
    line,
    style,
    ctx
  ) {
    ctx = ctx || this.context;
    let { x: x1, y: y1 } = pt1;
    let { x: x2, y: y2 } = pt2;
    ctx.beginPath();
    ctx.strokeStyle = style;
    ctx.lineWidth = line * this.dpr;
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
  }
  /*** 圆角矩形 ***/
  _drawBoxRadius({
                   left,
                   top,
                   width,
                   height,
                   lineWidth,
                   radius,
                   strokeStyle,
                   fillStyle,
                   ctx
                 }) {
    ctx = ctx || this.curContext;
    const right = left + width;
    const bottom = top + height;
    ctx.beginPath();
    lineWidth && (ctx.lineWidth = lineWidth);
    ctx.strokeStyle = strokeStyle;
    ctx.fillStyle = fillStyle;
    ctx.moveTo(left, top);
    ctx.arcTo(left, top, right, top, radius);
    ctx.arcTo(right, top, right, bottom, radius);
    ctx.arcTo(right, bottom, left, bottom, radius);
    ctx.arcTo(left, bottom, left, top, radius);
    ctx.arcTo(left, top, right, top, radius);
    ctx.closePath();
    ctx.stroke();
    ctx.fill();
  }
  /** 计算飘窗数据 **/
  _calcFloatWinData(x){
    const {left, width} = this.availArea
    const {
      current,
      // crc,
      // kline,
      period,
      min_time,
      code
    } = this.state.data;
    const defaultText = '--'
    const {preClosePx,prev_settlement,perHand,ratioFixed:priceFixed,hqTypeCode} = this.state.data.sealObj; // 昨收,交易单位
    const time_curr = String(min_time[current]); //当前时间
    const day = time_curr.slice(0,4)+'/'+time_curr.slice(4,6)+'/'+time_curr.slice(6,8); //格式化日期
    const time = time_curr.slice(8,10)+':'+time_curr.slice(10,12) // 格式化具体时间
    const {colorMap} = this.option.BaseContext;
    const color = '#666666'; // 普通颜色
    const context = this.curContext;
    let vx = 170 + x;
    let vy=100;
    let labelWidth =  context.measureText(min_time[current].value).width + 2*5;
    if (x > left + Math.max(width / 4*3, labelWidth)){
      vx=x-400
    }
    let contentTextX = vx + 100
    let radioFix = this.store.state.sealObj.ratioFixed;
    if(checkExchange(code)){
      radioFix = 4
    }
    if(period == 10 || period == 11) {
      const {avg_px, last_px, business_amount} = this.state.data;
      let pre_px = checkFutures(code) ? prev_settlement : preClosePx; // 期货市场昨收取昨结算字段
      // 分时及五日分时
      // 最新价 涨跌额 涨跌幅 均价 成交量
      // 最新价
      const last_px_value = last_px[current].value
      const last_px_o = {
        value: last_px_value == 0 ? defaultText : last_px_value.toFixed(priceFixed),
        color: last_px_value > pre_px ? colorMap[1] : (((last_px_value < pre_px) && last_px_value) ? colorMap[0] : color)
      }
      // 涨跌额：（最新-昨收）
      const change_value = last_px_value - pre_px
      const change_o = {
        value: change_value > 0 ? `+${change_value.toFixed(priceFixed)}` : (change_value == 0 ? (last_px_value == 0 ? `--` : `${change_value.toFixed(priceFixed)}`) : `${change_value.toFixed(priceFixed)}`),
        color: change_value > 0 ? colorMap[1] : (change_value < 0 ? colorMap[0] : color)
      }
      // 涨跌幅：(最新-昨收)/昨收 保留两位小数
      const change_rate_value =  pre_px ? (100 * change_value / pre_px) : 0
      const change_rate_o = {
        value: change_rate_value > 0 ? `+${change_rate_value.toFixed(2)}%` : (change_rate_value == 0 ? (pre_px == 0 ? `--` : `0.00%`) : `${change_rate_value.toFixed(2)}%`),
        color: change_value > 0 ? colorMap[1] : (change_value < 0 ? colorMap[0] : color)
      }
      let avg_o = undefined
      let avg_title = ''
      if(this.store.state.showAvg) {
        // 均价
        const avg_value = avg_px[current].value
        avg_title = checkMRI('', hqTypeCode) ? '领   先' : '均   价'
        avg_o = {
          value: avg_value == 0 ? defaultText : avg_value.toFixed(priceFixed),
          color: avg_value > pre_px ? colorMap[1] : (
            ((avg_value < pre_px) && avg_value) ? colorMap[0] : color)
        }
      }
      // 成交量
      const turnover_value = business_amount[current].value
      let turnover_text = TradVolume(turnover_value,code,perHand,2,last_px_value)
      const turnover_o = {
        value: turnover_text
      }

      const data = {
        title: ['Latest price','Up and down limit','Up and down range',avg_title,'Volume'],
        value:[last_px_o, change_o, change_rate_o, avg_o, turnover_o]
      }
      this.drawFloatWin(context,data,vx,vy-80,contentTextX,day+' '+time)
    }else {
      const { business_type }=this.store.state
      // const radioFix = checkExchange(code)?4:2
      const {kline} = this.state.data;
      const {
        business_amount:business_k_amount,
        business_balance,
        close_px,
        high_px,
        low_px,
        open_px,
        preclose_px,
        turnover_ratio,
        settlement,//结算价
        amount,//持仓量
        special_close_px,//16:30收盘价
      } = kline[current]
      // 开高低收涨跌额涨跌幅成交量成交额换手率
      // 开盘价
      const open_px_o = {
        value: open_px==0?defaultText:open_px.toFixed(radioFix),
        color: open_px > preclose_px ? colorMap[1] : (open_px < preclose_px ? colorMap[0] : color)
      }
      // 最高价
      const high_px_o = {
        value: high_px==0?defaultText:high_px.toFixed(radioFix),
        color: high_px > preclose_px ? colorMap[1] : (high_px < preclose_px ? colorMap[0] : color)
      }
      // 最低价
      const low_px_o = {
        value: low_px==0?defaultText:low_px.toFixed(radioFix),
        color: low_px > preclose_px ? colorMap[1] : (low_px < preclose_px ? colorMap[0] : color)
      }
      // 收盘价
      const close_px_o = {
        value: close_px==0?defaultText:close_px.toFixed(radioFix),
        color: close_px > preclose_px ? colorMap[1] : (close_px < preclose_px ? colorMap[0] : color)
      }
      // const change_value = last_px_value - preClosePx
      // 涨跌额
      let change_k_values = checkExchange(code)?close_px - open_px:close_px - preclose_px

      // const change_k_value =change_k_values ==0? zeroBug({self:change_k_values,refer_val:close_px,radioFix}):change_k_values.toFixed(radioFix)

      const change_k_value = zeroBug({self:change_k_values,refer_val:close_px,type:3,radioFix})
      const change_k_o = {
        value: change_k_value > 0 ? `+${change_k_value}` : `${change_k_value}`,
        color: change_k_value > 0 ? colorMap[1] : (change_k_value < 0 ? colorMap[0] : color)
      }
      // 涨跌幅
      // const change_rate_k_value = change_k_value==0?zeroBug({self:0,refer_val:close_px}):(checkExchange(code)?(change_k_value / open_px) * 100:(change_k_value / preclose_px) * 100).toFixed(2)

      const change_rate_k_values = checkExchange(code)?(change_k_value / open_px) * 100:(change_k_value / preclose_px) * 100;
      // console.log(typeof change_rate_k_values,change_rate_k_values,'change_rate_value')
      const change_rate_k_value = zeroBug({self:change_rate_k_values,refer_val:close_px});
      // const change_rate_k_value = zeroBug({self:change_rate_k_values,refer_val:close_px,radioFix})
      const change_rate_k_o = {
        value: change_rate_k_value > 0 ? `+${change_rate_k_value}%` : `${change_rate_k_value==defaultText?change_rate_k_value:change_rate_k_value+'%'}`,
        color: change_k_value > 0 ? colorMap[1] : (change_k_value < 0 ? colorMap[0] : color)
      }
      // 成交量
      let turnover_k_text = TradVolume(business_k_amount,code,perHand,2,close_px)
      const turnover_k_o = {
        value: turnover_k_text
      }
      //振幅
      const upAndLows = ((high_px-low_px)*100/preclose_px).toFixed(2)
      const upAndLow = zeroBug({self:upAndLows,refer_val:close_px})
      const change_high_low = {
        value: upAndLow==defaultText?upAndLow:upAndLow+'%'
      }
      // 成交额
      let busi_values =  zeroBug({self:business_balance,refer_val:close_px,type:2})
      // business_balance==0?defaultText:numberFormat(business_balance)
      let busi_value = typeof busi_values == 'string'?busi_values:numberFormat(business_balance)
      const busi_o = {
        value: busi_value
      }
      // 换手率
      let change_hand_o = {value:''};
      let change_hand_title = '';
      if(checkSS(code,'s')){
        change_hand_o.value =turnover_ratio==0||!turnover_ratio?defaultText:(turnover_ratio/100).toFixed(2)+'%';
        change_hand_title = '换手率';
      }
      let data=null;
      //外汇K线飘窗
      if(checkExchange(code)){
        //16:30收盘价
        const special_close_o={
          value: special_close_px==0?defaultText:special_close_px.toFixed(radioFix)
        }
        // 涨跌额
        const change_k_value = open_px==0?defaultText:close_px - open_px
        const change_k_for = {
          value: change_k_value > 0 ? `+${change_k_value.toFixed(radioFix)}` : `${change_k_value.toFixed(radioFix)}`
        }
        let foreignData=[]
        const type = business_type.split('.')[0]
        switch(type){
          case '2':
            foreignData = [open_px_o, high_px_o, low_px_o, close_px_o, change_k_for].map(function (item) {
              return {value:item.value}
            })
            data = {
              title: ['开盘价','最高价','最低价','最新价','涨跌额'],
              value: foreignData
            }
            this.drawFloatWin(context,data,vx,vy+60,contentTextX,time.length>1?(day+' '+time):day)
            break;
          default :
            foreignData = [ open_px_o, high_px_o, low_px_o, close_px_o, change_k_for,special_close_o ].map(function (item) {
              return {value:item.value}
            })
            data = {
              title: ['开盘价','最高价','最低价','最新价','涨跌额','16:30收'],
              value: foreignData
            }
            this.drawFloatWin(context,data,vx,vy+60,contentTextX,time.length>1?(day+' '+time):day)
            break;
        }
        return
      }
      //国内期货和国外期货
      if(checkFutures(code,'en_ch')||checkPower(code)){
        const endPrice = {
          value:!settlement?defaultText : settlement.toFixed(radioFix),//结算价
          color: !settlement ?'' : settlement>preclose_px?colorMap[1] :colorMap[0]
        }
        const haveNumbers = zeroBug({self:amount,refer_val:close_px,type:2})
        const haveNumber = {
          value:typeof haveNumbers == 'string'?haveNumbers:numberFormat(haveNumbers)//持仓量
        }
        data = {
          title: ['开盘价','最高价','最低价','收盘价','结算价','涨跌额','涨跌幅','成交量','持仓量'],
          value: [open_px_o, high_px_o, low_px_o, close_px_o, endPrice , change_k_o, change_rate_k_o,turnover_k_o,haveNumber]
        }
        this.drawFloatWin(context,data,vx,vy-40,contentTextX,time.length>1?(day+' '+time):day)
        return;
      }
      //上证+深证股票,沪深板块
      data = {
        title: ['Opening price','Maximum price','Minimum price','Closing price','Rise and fall','Up and down','Volume','Turnover','Amplitude',change_hand_title],
        value: [open_px_o, high_px_o, low_px_o, close_px_o, change_k_o, change_rate_k_o, turnover_k_o, busi_o,change_high_low, change_hand_o]
      }
      this.drawFloatWin(context,data,vx,vy-95,contentTextX,time.length>1?(day+' '+time):day)
      // const data = {
      //   title: ['开盘价','最高价','最低价','收盘价','涨跌额','涨跌幅','成交量','成交额',change_hand_title],
      //   value: [open_px_o, high_px_o, low_px_o, close_px_o, change_k_o, change_rate_k_o, turnover_k_o, busi_o, change_hand_o]
      // }
      // this.drawFloatWin(context,data,vx,vy-40,contentTextX,time.length>1?(day+' '+time):day)
    }
  }

  /** 飘窗绘制 **/
  drawFloatWin(context,data,vx,vy,contentTextX,title){
    // context:画布实例，vx：离画布左侧的距离，vy离画布顶部的距离，contentTextX：文字离飘窗左边的距离，title:飘窗的标题
    context.beginPath();

    const dataTitle = data.title.filter(function (item,index) {
      return item!=''
    })
    const dataValue = data.value.filter(function (item,index) {
      return item!=undefined
    })
    const height=120+30*dataTitle.length
    context.moveTo(vx, vy);
    context.lineTo(vx+455, vy);
    context.lineTo(vx+455, vy+height);
    context.lineTo(vx, vy+height);
    context.lineTo(vx, vy); //绘制最后一笔使图像闭合
    context.fillStyle='#fff';
    // context.lineWidth = 0.4;
    context.strokeStyle = 'rgba(78,171,249,1)'
    context.fill();
    context.stroke();
    context.moveTo(vx,vy+64)
    context.lineTo(vx+455, vy+64);
    context.lineWidth = 0.6;
    context.strokeStyle = '#095a9f'
    context.fill();
    context.stroke();
    // 文字
    context.fillStyle="#666666";
    context.font='24px Arial'
    dataTitle.forEach(function (item,index) {
      if(item.length>7){
        context.font='20px Arial';
        context.fillText(item.substring(0,25),contentTextX,vy+110+index*30);
        context.fillText(item.substring(25),contentTextX,vy+130+index*30);
      }else {
        context.fillText(item,contentTextX-15,vy+110+index*30);
      }
    })
    context.font='24px Arial'
    //值和值的颜色
    dataValue.forEach(function (item,index) {
      if(item.color!=undefined){
        context.fillStyle = item.color;
      }else {
        context.fillStyle = '#333333';
      }
      context.textAlign = 'right';
      context.fillText(item.value,vx+435,vy+110+index*30);
    })
    // // 头
    context.fillStyle='#4EABF9'
    context.font='24px Arial bold'
    context.textAlign = 'center';
    // //头部标题内容
    title.length<=10?context.fillText(title,vx+140,vy+35):context.fillText(title,vx+190,vy+35)
    context.textBaseline = 'middle';
    context.closePath()
    return context
  }
  /*** 标签 ***/
  _drawLable({
               x,
               y,
               width,
               height,
               lineWidth,
               radius,
               strokeStyle,
               fillStyle,
               ctx,
               triangleWidth,
               text,
               fontSize,
               fontFamily,
               color,
               direction = DIRECTION_TOP,
             }) {
    ctx = ctx || this.context;
    radius = radius || this.dpr;
    const baseSize = this.state.baseSize;
    const _axisYSpace = triangleWidth * Math.sqrt(3) / 2;
    if (direction === DIRECTION_TOP) {
      y += _axisYSpace;
    } else {
      y -= _axisYSpace - height
    }
    this._drawBoxRadius({
      ctx,
      left: x - width / 2,
      top: y,
      width,
      height,
      radius,
      strokeStyle,
      fillStyle
    });
    ctx.beginPath();
    ctx.font = fontSize * this.dpr + 'px ' + fontFamily;
    ctx.fillStyle = color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, x, y + height / 2)
  }
  /**
   *
   */
  _drawUpArrow({
                 x,
                 y,
                 width,
                 height,
                 color,
                 ctx2 = this.curContext,
                 lineWidth = this.dpr,
               }) {
    ctx2.beginPath();
    ctx2.fillStyle = color;
    ctx2.strokeStyle = color;
    ctx2.lineWidth = lineWidth;
    ctx2.moveTo(x + width / 2, y);
    ctx2.lineTo(x + width, y + height / 3);
    ctx2.lineTo(x + width * 2 / 3, y + height / 3);
    ctx2.lineTo(x + width * 2 / 3, y + height);
    ctx2.lineTo(x + width / 3, y + height);
    ctx2.lineTo(x + width / 3, y + height / 3);
    ctx2.lineTo(x, y + height / 3);
    ctx2.closePath();
    ctx2.fill();
  }
  /**
   *
   */
  _drawDownArrow({
                   x,
                   y,
                   width,
                   height,
                   color,
                   ctx2 = this.curContext,
                   lineWidth = this.dpr,
                 }) {
    ctx2.beginPath();
    ctx2.fillStyle = color;
    ctx2.strokeStyle = color;
    ctx2.lineWidth = lineWidth;
    ctx2.moveTo(x + width / 3, y);
    ctx2.lineTo(x + width * 2 / 3, y);
    ctx2.lineTo(x + width * 2 / 3, y + height * 2 / 3);
    ctx2.lineTo(x + width, y + height * 2 / 3);
    ctx2.lineTo(x + width / 2, y + height);
    ctx2.lineTo(x, y + height * 2 / 3);
    ctx2.lineTo(x + width / 3, y + height * 2 / 3);
    ctx2.closePath();
    ctx2.fill();
  }
  /*** 折线图及渐变背景色 ***/
  _drawLine(
    type,
    data,
    left,
    bottom,
    line,
    style,
    { space, width } = {}
  ) {
    let ctx = this.context;
    const len = data.length;
    const { LINE, GRIDENT } = LINE_TYPE;
    if (!Util.isArray(data)) {
      return;
    }
    const { top, bottom: gridentBottom, right, barSpace, barWidth } = this.availArea;
    if (!Util.isValidNumber(top) || !Util.isValidNumber(gridentBottom)) {
      return;
    }
    let { start, end } = this.state.data;
    /*
    五日分时趋势图需按日分段绘制
    增加end判断防止数组越界
     */
    let lineEnd = Math.min(end, len);
    if (start >= lineEnd) {
      return;
    }
    space = barSpace + barWidth;
    ctx.beginPath();
    switch (type) {
      case LINE:
        ctx.lineWidth = line * this.dpr;
        ctx.strokeStyle = style;
        if (start > 0) {
          // 画头部半条
          ctx.moveTo(left, bottom - (data[start - 1].lineY + data[start].lineY) / 2);
          left += barWidth / 2;
        } else {
          left += barWidth / 2;
          ctx.moveTo(left, bottom - data[start].lineY);
        }
        break;
      case GRIDENT:
        try {
          let gradient = ctx.createLinearGradient(left, top, left, gridentBottom);
          for (let i in style) {
            gradient.addColorStop(i, style[i]);
          }
          ctx.fillStyle = gradient;
        } catch (e) {
        }
        ctx.moveTo(left, bottom);
        break;
      default:
        break;
    }
    let _axisX;
    for (let i = start; i < lineEnd; i++) {
      _axisX = left + space * (i - start);
      ctx.lineTo(_axisX, bottom - data[i].lineY);
    }
    // 画尾部半条
    if (lineEnd < len) {
      _axisX = Math.min(left + space * (lineEnd - start), right);
      ctx.lineTo(_axisX, bottom - (data[lineEnd - 1].lineY + data[lineEnd - 1].lineY) / 2);
    }
    if (type === GRIDENT) {
      ctx.lineTo(_axisX, bottom);
      ctx.closePath();
      ctx.fill();
    } else {
      ctx.stroke();
    }
  }
  /*** 柱状图 ***/
  _drawBar(
    data,
    left,
    bottom,
    viewWidth
  ) {
    if (!Util.isArray(data)) {
      return;
    }
    const len = data.length;
    let { start = 0, end = len } = this.state.data;
    const barEnd = Math.min(end, len);
    // console.log('试试这里是否可以画出最后一根线',start,end,len,data.length,data)//data的最后一个value是0并且x轴只到59
    if (start >= barEnd) {
      return;
    }
    const { colorMap } = this.option.BaseContext;
    const { barWidth: width, barSpace: space } = this.availArea;
    let ctx = this.context;
    let _axisX = left,list = [];
    for (let i = start; i < barEnd; i++) {
      // ctx.fillStyle = colorMap[data[i].barColor];
      let _axisY = bottom - data[i].barHeight;
      // ctx.moveTo(_axisX, bottom);
      // ctx.lineTo(_axisX, _axisY);
      // _axisX += width;
      // ctx.lineTo(_axisX, _axisY);
      // ctx.lineTo(_axisX, bottom);
      const x1 = _axisX;
      _axisX += width;
      const height = _axisY - bottom
      list.push({x1:x1,height:height,color:data[i].barColor})
      _axisX += space;
    }
    const up = list.filter(item=>item.color==1);
    const down = list.filter(item=>item.color==0)
    ctx.fillStyle = colorMap[1];
    ctx.beginPath();
    up.forEach(function (item) {
      ctx.rect(item.x1,bottom,width,item.height)
    })
    ctx.fill();
    ctx.closePath();
    ctx.fillStyle = colorMap[0];
    ctx.beginPath();
    down.forEach(function (item) {
      ctx.rect(item.x1,bottom,width,item.height)
    })
    ctx.fill();
    ctx.closePath();
  }
  /**修改MACD柱状图 **/
  _drawBarMacd(
    data,
    left,
    bottom,
    viewWidth
  ) {
    if (!Util.isArray(data)) {
      return;
    }
    const len = data.length;
    let { start = 0, end = len } = this.state.data;
    const barEnd = Math.min(end, len);
    if (start >= barEnd) {
      return;
    }
    const { colorMap } = this.option.BaseContext;
    const { barWidth: width, barSpace: space } = this.availArea;
    let ctx = this.context;
    let _axisX = left + (width - 2) / 2;
    let list = [];
    for (let i = start; i < barEnd; i++) {
      // ctx.fillStyle = colorMap[data[i].barColor];
      let _axisY = bottom - data[i].barHeight;
      const x1 = _axisX;
      // _axisX += 2;
      // const x2 = _axisX;
      // const y1 = bottom;
      const y2 = _axisY;
      list.push({x1:x1,y2:y2,color:data[i].barColor})
      _axisX += space + width;
    }
    const up = list.filter(item=>item.color==1);
    const down = list.filter(item=>item.color==2||item.color==0)
    ctx.fillStyle = colorMap[1];
    ctx.beginPath();
    up.forEach(function (item) {
      ctx.rect(item.x1,item.y2,2,bottom-item.y2)
    })
    ctx.fill();
    ctx.closePath();
    ctx.fillStyle = colorMap[2];
    ctx.beginPath();
    down.forEach(function (item) {
      ctx.rect(item.x1,item.y2,2,bottom-item.y2)
    })
    ctx.fill();
    ctx.closePath();
  }
  /*** K线图 ***/
  _drawKline(
    data,
    left,
    bottom
  ) {
    if (!Util.isArray(data)) {
      return;
    }
    // const { kline } = this.store.state;
    const len = data.length;
    let { start = 0, end = len } = this.state.data;
    let kEnd = Math.min(end, len);
    if (start >= kEnd) {
      return;
    }
    const { colorMap } = this.option.BaseContext;
    const { barWidth: width, barSpace: space, right } = this.availArea;
    const halfWidth = width / 2;
    const ctx = this.context;
    ctx.lineWidth = this.dpr;
    let _axisX = left,rectList =[];

    // let asideCanvas = document.createElement('canvas');
    // asideCanvas.width = ctx.width;
    // asideCanvas.height = ctx.height;
    // this.store.state.asideCanvas = asideCanvas.getContext("2d");
    // ctx.render(this.store.state.asideCanvas);
    for (let i = start; i < kEnd; i++) {
      /*** kHeight为从高到低的坐标值数组 ***/
      const { kColor, kHeight } = data[i];
      const height = kHeight[1].lineY - kHeight[2].lineY;
      const y = bottom - kHeight[1].lineY
      const _axisYO = bottom - kHeight[2].lineY;//开盘点
      const _axisYH = bottom - kHeight[0].lineY;//高点
      const _axisYL = bottom - kHeight[3].lineY;//低点
      const _axisYR = bottom - kHeight[1].lineY;//收点
      const _middleX = _axisX + halfWidth;
      const RectObj = {
        x: _axisX,
        y: y,
        width:width,
        _middleX:_middleX,
        _axisYO:_axisYO,
        _axisYL:_axisYL,
        _axisYR:_axisYR,
        _axisYH:_axisYH,
        height:height,
        color:kColor,
        cahe:false,
        ctx
      }
      // if(!kline[i].cahe){
      //   rectList.push(RectObj)
      //   kline[i].cahe = true
      // }
      rectList.push(RectObj)
      _axisX += width + space
    }

    const up = rectList.filter(item=>item.color == 1);
    const down = rectList.filter(item=>item.color == 0);
    // ctx.save()
    ctx.beginPath();
    ctx.fillStyle = colorMap[1];
    ctx.strokeStyle = colorMap[1];
    up.forEach(function (item) {
      new RectObjs(item)
    })
    ctx.stroke();
    ctx.beginPath();
    ctx.fillStyle = colorMap[0];
    ctx.strokeStyle = colorMap[0];
    down.forEach(function (item) {
      new RectObjs(item)
    })
    ctx.stroke();
    // ctx.restore()


    //原
    // for (let i = start; i < kEnd; i++) {
    //   /*** kHeight为从高到低的坐标值数组 ***/
    //   const { kColor, kHeight } = data[i];
    //   const color = colorMap[kColor];
    //   ctx.fillStyle = color;
    //   ctx.strokeStyle = color;
    //   /*** K线图矩形 ***/
    //   ctx.beginPath();
    //   let _axisY = bottom - kHeight[1].lineY;
    //   ctx.moveTo(_axisX, _axisY);
    //   ctx.lineTo(_axisX + width, _axisY);
    //   _axisY = bottom - kHeight[2].lineY;
    //   ctx.lineTo(_axisX + width, _axisY);
    //   ctx.lineTo(_axisX, _axisY);
    //   ctx.closePath();
    //   ctx.stroke();
    //   ctx.fill();
    //   /*** K线图线 ***/
    //   ctx.beginPath();
    //   const _middleX = _axisX + halfWidth;
    //   ctx.moveTo(_middleX, _axisY);
    //   _axisY = bottom - kHeight[3].lineY;
    //   ctx.lineTo(_middleX, _axisY);
    //   _axisY = bottom - kHeight[1].lineY;
    //   ctx.moveTo(_middleX, _axisY);
    //   _axisY = bottom - kHeight[0].lineY;
    //   ctx.lineTo(_middleX, _axisY);
    //   ctx.stroke();
    //   _axisX += width + space;
    //
    // }
  }
  /*** K线美国线图 ***/
  _drawKlineUS(
    data,
    left,
    bottom
  ) {
    if (!Util.isArray(data)) {
      return;
    }
    const len = data.length;
    let { start = 0, end = len } = this.state.data;
    const kEnd = Math.min(end, len);
    if (start >= kEnd) {
      return;
    }
    const { colorMap } = this.option.BaseContext;
    const { barWidth: width, barSpace: space, right } = this.availArea;
    const halfWidth = width / 2;
    const ctx = this.context;
    ctx.lineWidth = this.dpr;
    let _axisX = left;
    for (let i = start; i < kEnd; i++) {
      /*** kHeight为从高到低的坐标值数组 ***/
      const { kColor, kHeight } = data[i];
      const color = colorMap[kColor];
      ctx.fillStyle = color;
      ctx.strokeStyle = color;
      /*kHeight 存储数据 跌['high_px', 'open_px', 'close_px', 'low_px']
      kHeight 存储数据 涨['high_px', 'close_px', 'open_px', 'low_px'] */
      /*** 纵线 ***/
      ctx.beginPath();
      const _middleX = _axisX + halfWidth;
      let _axisY = bottom - kHeight[0].lineY; // high_px
      ctx.moveTo(_middleX, _axisY);
      _axisY = bottom - kHeight[3].lineY; // low_px
      ctx.lineTo(_middleX, _axisY);
      /* 涨：开盘价向左 跌：收盘价向左 */
      _axisY = bottom - kHeight[2].lineY;
      ctx.moveTo(_middleX, _axisY);
      ctx.lineTo(_middleX - halfWidth, _axisY);
      /* 涨：收盘价向右 跌：开盘价向右 */
      _axisY = bottom - kHeight[1].lineY;
      ctx.moveTo(_middleX, _axisY);
      ctx.lineTo(_middleX + halfWidth, _axisY);
      ctx.stroke();
      _axisX += width + space;
    }
  }
  /*** KD ***/
  _drawKD(
    data,
    left,
    bottom,
    viewWidth
  ) {
    if (!Util.isArray(data)) {
      return;
    }
    const len = data.length;
    let { dList, kList, start, end = len } = this.state.data;
    const kEnd = Math.min(end, len);
    if (start >= kEnd) {
      return;
    }
    const baseSize = this.state.baseSize;
    const { barWidth: width, barSpace: space } = this.availArea;
    const halfWidth = width / 2;
    const {
      sizeRatio,
      fontFamily,
      k,
      d,
      radius,
    } = this.option.KD;
    const {
      kdWidth,
      kdHeight,
      triangleWidth,
      verticalSpace,
    } = this.measureKDLabel({
      text: 'K',
      fontSize: sizeRatio * baseSize * this.dpr,
      fontFamily
    });
    const ctx = this.context;
    ctx.lineWidth = this.dpr;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    const deltaX = kdWidth / 2;
    const deltaY = verticalSpace + Math.sqrt(3) * triangleWidth;
    ctx.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
    dList.filter(a => a >= start && a < end).forEach(i => {
      /*** kHeight为从高到低的坐标值数组 ***/
      const { kHeight } = data[i];
      const _axisX = (width + space) * (i - start) + halfWidth + left;
      const _axisY = bottom - kHeight[3].lineY;
      this._drawBoxRadius({
        ctx,
        left: _axisX - deltaX,
        top: _axisY + deltaY,
        width: kdWidth,
        height: kdHeight,
        lineWidth: this.dpr,
        radius: radius * this.dpr,
        strokeStyle: d.backColor,
        fillStyle: d.backColor
      });
      ctx.strokeStyle = d.backColor;
      ctx.fillStyle = d.backColor;
      ctx.beginPath();
      ctx.moveTo(_axisX, _axisY + verticalSpace);
      ctx.lineTo(_axisX + triangleWidth, _axisY + deltaY);
      ctx.lineTo(_axisX - triangleWidth, _axisY + deltaY);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();

      ctx.fillStyle = d.color;
      ctx.fillText(d.text, _axisX, _axisY + deltaY + kdHeight / 2);
    });
    kList.filter(a => a >= start && a < end).forEach(i => {
      /*** kHeight为从高到低的坐标值数组 ***/
      const { kHeight } = data[i];
      const _axisX = (width + space) * (i - start) + halfWidth + left;
      const _axisY = bottom - kHeight[0].lineY;
      this._drawBoxRadius({
        ctx,
        left: _axisX - deltaX,
        top: _axisY - deltaY - kdHeight,
        width: kdWidth,
        height: kdHeight,
        lineWidth: this.dpr,
        radius: radius * this.dpr,
        strokeStyle: k.backColor,
        fillStyle: k.backColor
      });
      ctx.fillStyle = k.backColor;
      ctx.strokeStyle = k.backColor;
      ctx.beginPath();
      ctx.moveTo(_axisX, _axisY - verticalSpace);
      ctx.lineTo(_axisX + triangleWidth, _axisY - deltaY);
      ctx.lineTo(_axisX - triangleWidth, _axisY - deltaY);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();

      ctx.fillStyle = k.color;
      ctx.fillText(k.text, _axisX, _axisY - deltaY - kdHeight / 2);
    })
  }
  measureKDLabel({
                   text,
                   fontSize,
                   fontFamily
                 }) {
    const ctx = this.context;
    ctx.font = fontSize + 'px ' + fontFamily;
    const kdWidth = ctx.measureText(text).width * 1.8;
    const kdHeight = kdWidth * 1.1;
    const triangleWidth = kdWidth * 0.15;
    const verticalSpace = kdWidth * 0.5;
    return {
      kdWidth,
      kdHeight,
      triangleWidth,
      verticalSpace,
    };
  }
  /*** JQJZ ***/
  _drawJQJZ(
    data,
    left,
    bottom,
    viewWidth
  ) {
    if (!Util.isArray(data)) {
      return;
    }
    const len = data.length;
    let { jqRiseList, jqFallList, start, end = len } = this.state.data;
    const kEnd = Math.min(end, len);
    if (start >= kEnd) {
      return;
    }
    const baseSize = this.state.baseSize;
    const { barWidth: width, barSpace: space } = this.availArea;
    const halfWidth = width / 2;
    let {
      rise,
      fall,
      radius,
      sizeRatio,
      fontFamily,
    } = this.option.JQJZ;
    const {
      jqWidth,
      jqHeight,
      triangleWidth,
      verticalSpace,
    } = this.measureJQJZLabel({
      text: '9',
      fontSize: sizeRatio * baseSize * this.dpr,
      fontFamily
    });
    const deltaX = jqWidth / 2;
    const deltaY = verticalSpace + Math.sqrt(3) * triangleWidth;
    const ctx = this.context;
    ctx.lineWidth = this.dpr;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
    jqRiseList.filter(a => a.index >= start && a.index < end).forEach(item => {
      const { index: i, value } = item;
      ctx.strokeStyle = rise.backColor;
      ctx.fillStyle = rise.backColor;
      /*** lineYData为从高到低的坐标值数组 ***/
      let { kHeight, lineY } = data[i];
      const _axisX = (width + space) * (i - start) + halfWidth + left;
      const _axisY = bottom - (lineY || kHeight[3].lineY);
      if (value !== 9) {
        ctx.fillText(value, _axisX, _axisY + deltaY + jqHeight / 2)
      } else {
        this._drawBoxRadius({
          ctx,
          left: _axisX - deltaX,
          top: _axisY + deltaY,
          width: jqWidth,
          height: jqHeight,
          lineWidth: this.dpr,
          radius: radius * this.dpr,
          strokeStyle: rise.backColor,
          fillStyle: rise.backColor
        });
        ctx.beginPath();
        ctx.moveTo(_axisX, _axisY + verticalSpace);
        ctx.lineTo(_axisX + triangleWidth, _axisY + deltaY);
        ctx.lineTo(_axisX - triangleWidth, _axisY + deltaY);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();

        ctx.fillStyle = rise.color;
        ctx.fillText(value, _axisX, _axisY + deltaY + jqHeight / 2);
      }
    });
    jqFallList.filter(a => a.index >= start && a.index < end).forEach(item => {
      const { index: i, value } = item;
      ctx.strokeStyle = fall.backColor;
      ctx.fillStyle = fall.backColor;
      /*** lineYData为从高到低的坐标值数组 ***/
      let { kHeight, lineY } = data[i];
      const _axisX = (width + space) * (i - start) + halfWidth + left;
      const _axisY = bottom - (lineY || kHeight[0].lineY);
      if (value !== 9) {
        ctx.fillText(value, _axisX, _axisY - deltaY - jqHeight / 2);
      } else {
        this._drawBoxRadius({
          ctx,
          left: _axisX - deltaX,
          top: _axisY - deltaY - jqHeight,
          width: jqWidth,
          height: jqHeight,
          lineWidth: this.dpr,
          radius: radius * this.dpr,
          strokeStyle: fall.backColor,
          fillStyle: fall.backColor
        });
        ctx.beginPath();
        ctx.moveTo(_axisX, _axisY - verticalSpace);
        ctx.lineTo(_axisX + triangleWidth, _axisY - deltaY);
        ctx.lineTo(_axisX - triangleWidth, _axisY - deltaY);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();

        ctx.fillStyle = fall.color;
        ctx.fillText(value, _axisX, _axisY - deltaY - jqHeight / 2);
      }
    });
  }

  measureJQJZLabel({
                     text,
                     fontSize,
                     fontFamily
                   }) {
    const ctx = this.context;
    ctx.font = fontSize + 'px ' + fontFamily;
    const jqWidth = ctx.measureText(text).width * 1.4;
    const jqHeight = jqWidth * 1.3;
    const triangleWidth = jqWidth * 0.15;
    const verticalSpace = jqWidth * 0.5;
    return {
      jqWidth,
      jqHeight,
      triangleWidth,
      verticalSpace,
    };
  }

  /*** 静态画布，根据后台数据重绘 ***/
  _calcGrid() { }
  calcRange({
              data,
              targetKey,
              fixMinValue,
              isAdditional = false
            }) {
    if (!Util.isArray(data)) {
      throw new Error(`${Object.prototype.toString.apply(data)} constructor is not [object, Array]`);
    }
    let { start, end, len } = this.state.data;
    if (isAdditional) {
      start = start > 0 ? start - 1 : start;
      end = end < len ? end + 1 : end;
    }
    let maxValue = this.maxValue;
    let minValue;
    if (!Util.isValidNumber(fixMinValue)) {
      minValue = this.minValue;
    } else {
      minValue = fixMinValue;
    }
    const getArrayValue = a => {
      let arrayData = a.slice(start, end).map(b => b[targetKey]).filter(c => Util.isValidNumber(c));
      if(arrayData.length==0){
        arrayData = a
      }
      const _maxValue = Math.max.apply(null, arrayData);
      const _minValue = Math.min.apply(null, arrayData);
      if (Util.isValidNumber(_maxValue)) {
        if (Util.isValidNumber(maxValue)) {
          maxValue = Math.max(maxValue, _maxValue);
        } else {
          maxValue = _maxValue;
        }
      }
      if (Util.isValidNumber(_minValue)) {
        if (Util.isValidNumber(minValue)) {
          minValue = Math.min(minValue, _minValue);
        } else {
          minValue = _minValue;
        }
      }
    }
    if (data.every(a => Util.isArray(a))) {
      data.forEach(a => {
        getArrayValue(a)
      })
    } else {
      getArrayValue(data);
    }
    if(maxValue==null){
      maxValue = 0
    }
    if(minValue==null){
      minValue = 0
    }
    this.maxValue = maxValue;
    this.minValue = minValue;
    return { maxValue, minValue };
  }
  _calcRange() { }
  calcAxis({
             data,
             targetKey,
             sourceKey,
             isAdditional = false,
             baseValue,
             indexRF
           }) {
    // 计算各个点的Y轴坐标
    const { height } = this.availArea;
    const maxValue = this.maxValue;
    const minValue = this.minValue;
    baseValue = Util.isValidNumber(baseValue) ? baseValue : minValue;
    const ratio = height / (maxValue - minValue);
    let { start, end, len } = this.state.data;
    if (isAdditional) {
      start = start > 0 ? start - 1 : start;
      end = end < len ? end + 1 : end;
    }
    if (Util.isArray(data)) {
      data.slice(start, end).forEach(item => {
        if (indexRF) {
          item[sourceKey] = item[targetKey] * ratio
        } else {
          item[sourceKey] = (item[targetKey] - baseValue) * ratio;
        }
      })
    }
  }
  _calcAxis() { }
  _drawGrid() { }
  _calcSpace() {
    // 计算space和width
    const { width: viewWidth } = this.availArea;
    const { start, end } = this.state.data;
    const amount = end - start;
    const { spaceRatio } = this.option.BaseContext;
    const width = viewWidth * (1 - spaceRatio) / amount;
    const space = amount === 1 ? 0 : viewWidth * spaceRatio / (amount - 1);
    this.availArea.barWidth = width;
    this.availArea.barSpace = space;
  }
  _drawMain() { }
  _drawAxisX() { }
  _drawAxisY() { }
  /*** 动态画布，根据手势触发重绘 ***/
  _drawTitle() { }
  swipe({ start, end, current, axisX }) {
    const { start: oldStart, end: oldEnd } = this.state.data;
    if (oldStart === start && oldEnd === end) {
      /**
       * 切换tab时重置store的start和end会发布消息
       * 无需重绘
       */
      return;
    }
    this.setData({
      start,
      current,
      end,
      axisX,
    });
    this.draw();
  }
  showCursor(x,type) {
    if(x==null){
      return
    }
    const ctx2 = this.curContext;
    const { min_time, start, end, kline } = this.state.data;
    const { left, top, width, height, barWidth, barSpace } = this.availArea;
    const len = Math.min(min_time.length, end);
    if(type=='noFirst'){
      x=this.store.state.xValue*2
    }
    const round = Math.max(Math.round((end - 1 - start) * ((x - left) / width)), 0) + start;
    const index = Math.max(Math.min(round, len - 1), 0);
    this.setData({
      current: index
    });
    x = (index - start) * (barWidth + barSpace) + barWidth / 2 + left;
    //十字线在这里绘制的
    this._showCursor({ x, index });
    this._drawTitle();
    return index;
  }
  hideCursor(hideTitle) {
    const { end, min_time } = this.state.data;
    const len = min_time.length;
    const current = Math.max(Math.min(end - 1, len - 1), 0);
    this.setData({
      current
    });
    this._hideCursor();
    !hideTitle && this._drawTitle();
    return current;
  }
  _showCursor({
                x,
                y,
                text
              }) { }
  _calcCursorAxis(
    x,
    index
  ) { }
  _hideCursor() { }
  tap({
        x,
        y
      }) {
    // 校验是否在是实例对象的有效区域内
    const { left, top, right, bottom, width } = this.availArea;
    // 无权限的为点击左侧2/3区域切换，右侧1/3区域跳转
    const middleX = left + width * 2 / 3;
    if (x > left
      && x < right
      && y > top
      && y < bottom
    ) {
      if (!this.auth && x > middleX) {
        return false;
      }
      return true;
    }
  }
  /*** 容器大小变化时触发 ***/
  resize(arg) {
    this.state = { ...this.state, ...arg };
    if (this.state.data) {
      // 不绘制title
      this.hideCursor(true);
      this.draw();
    }
  }
  async draw() {
    //试下在这里吧函数放入worker中进行
    this.preDraw();
    await this.drawMain();
    if (this.store.state.isPress) {
      this.showCursor(this.store.state.xValue,'noFirst')
    }
    this.nextDraw();
  }
  preDraw() {
    // 重绘时初始化range
    const ctx = this.context;
    const ctx2 = this.curContext;
    const {
      left,
      top,
      width,
      height
    } = this.state;
    if (this.option.FootContext.size.top == -2) {
      // 仅指标部分的组件清空绘图做特殊处理
      ctx.clearRect(left, 0, width, height + top);
      ctx2.clearRect(left, 0, width, height + top);
    } else {
      ctx.clearRect(left, top, width, height);
      ctx2.clearRect(left, top, width, height);
    }
    this.maxValue = undefined;
    this.minValue = undefined;
    this.baseValue = undefined;
    this._calcGrid(); // 计算availArea, 限定于Foot和Main修饰器
    this._calcSpace(); // 计算availArea, 限定于BaseContext
    this._drawGrid(); // 画坐标轴, 限定于Foot和Main修饰器
  }
  drawMain() {
    /**
     * 由各自状态类实现
     */
    //画主图，计算坐标，计算Y轴数值范围花的时间多
    this._calcRange(); // 计算Y轴数值范围//东方财富是写死的
    this._calcAxis(); // 计算坐标
    this._drawMain(); // 画主图

    this._drawAxisY(); // 画Y轴数值
    if(!this.store.state.isPress) {
      // 没有覆盖时 title默认绘制最后一根 否则在showCursor()触发当前x的title
      this._drawTitle(); // 画左上角Title
    }

  }
  drawMainNoAuth() { }
  nextDraw() {
    this._drawAxisX(); // 画X轴数值
  }

  setData(data) {
    for (let key in data) {
      this.state.data[key] = data[key];
    }
  }
  destroy() {
    return true;
  }
}
